exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.searchExpandPanel .v-expansion-panel-header {\n    padding: 0 12px !important;\n    min-height: 38px !important;\n}\n", ""]);
